import {
  bradycardiaChecklist,
  feverChecklist,
  hyperglycemiaChecklist,
  hypertensionChecklist,
  hypoglycemiaChecklist,
  hypotensionChecklist,
  hypothermiaChecklist,
  hypoxiaChecklist,
  respiratoryDistressChecklist,
  tachycardiaChecklist,
} from './checklists';

import type { OutOfRangeParam } from '../engine/types';
import type { TFormItem } from '../../types';

export interface DisplayedChecklist {
  key: string;
  title: string;
  items: TFormItem[];
}

const pick = (p: OutOfRangeParam): DisplayedChecklist | null => {
  const hi = p.direction === 'high';
  switch (p.param) {
    case 'systolic':
    case 'diastolic':
      return hi
        ? {
            key: 'hypertension',
            title: 'Hypertension',
            items: hypertensionChecklist,
          }
        : {
            key: 'hypotension',
            title: 'Hypotension',
            items: hypotensionChecklist,
          };
    case 'pulse':
      return hi
        ? {
            key: 'tachycardia',
            title: 'Tachycardia',
            items: tachycardiaChecklist,
          }
        : {
            key: 'bradycardia',
            title: 'Bradycardia',
            items: bradycardiaChecklist,
          };
    case 'oxygen':
      return { key: 'hypoxia', title: 'Hypoxia', items: hypoxiaChecklist };
    case 'glucose':
      return hi
        ? {
            key: 'hyperglycemia',
            title: 'Hyperglycemia',
            items: hyperglycemiaChecklist,
          }
        : {
            key: 'hypoglycemia',
            title: 'Hypoglycemia',
            items: hypoglycemiaChecklist,
          };
    case 'pef':
    case 'fev1':
      return {
        key: 'respiratory-distress',
        title: 'Respiratory Distress',
        items: respiratoryDistressChecklist,
      };
    case 'temperature':
      return hi
        ? { key: 'fever', title: 'Fever', items: feverChecklist }
        : {
            key: 'hypothermia',
            title: 'Hypothermia',
            items: hypothermiaChecklist,
          };
    default:
      return null;
  }
};

export const getChecklistsFor = (
  params: OutOfRangeParam[],
): DisplayedChecklist[] => {
  const seen = new Set<string>();
  const out: DisplayedChecklist[] = [];
  for (const p of params) {
    const cl = pick(p);
    if (cl && !seen.has(cl.key)) {
      seen.add(cl.key);
      out.push(cl);
    }
  }
  return out;
};
